import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import axios from 'config/axios';
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { setAlert } from 'store/error';
import { Test } from 'global/types';

import MyTests from '../MyTests';
import './index.css';

function SAT() {
    const [tabIndex, setTabIndex] = useState(0);
    const [myTests, setMyTests] = useState<Test[]>([]);

    const dispatch = useAppDispatch();
    const { organization } = useAppSelector(state => state.organization);

    useEffect(() => {
        axios.get(`tests/sat/${organization.urlSlug}/`)
            .then(res => {
                const { myTests } = res.data;

                // console.log(res.data);

                setMyTests(myTests);
            })
            .catch(error => {
                dispatch(setAlert(error));
            });
    }, []);

    return (
        <div className='layout'>
            <Helmet>
                <title>
                    My SAT - {organization.name}
                </title>
            </Helmet>
            <div className='tests'>
                <div className='tests__tabs'>
                    <button
                        className={tabIndex === 0 ? 'tests__tab--active' : 'tests__tab'}
                        onClick={() => setTabIndex(0)}
                    >
                        My SAT
                    </button>
                    <div className={tabIndex === 0
                        ? 'tests__tabIndicatorLeft'
                        : 'tests__tabIndicatorRight'
                    }></div>
                </div>
                <MyTests tests={myTests} testType={'digital-sat'}/>
            </div>
        </div>
    );
}

export default SAT;